import type { MsalPopupAuthenticator } from './embed';
import type { MsalRedirectAuthenticator } from './redirect';
import type { Authenticator } from './types';
import { AuthenticatorType } from './types';
import type { YammerJwtAuthenticator } from './yammerJwt';

type DoesAuthenticatorSupportScopes = (
  authenticator: Authenticator
) => authenticator is MsalRedirectAuthenticator | MsalPopupAuthenticator | YammerJwtAuthenticator;
export const doesAuthenticatorSupportScopes: DoesAuthenticatorSupportScopes = (
  authenticator
): authenticator is MsalRedirectAuthenticator | MsalPopupAuthenticator | YammerJwtAuthenticator =>
  [
    AuthenticatorType.MsalPopup,
    AuthenticatorType.MsalRedirect,
    AuthenticatorType.YammerJwt,
    AuthenticatorType.NestedAppAuth,
    AuthenticatorType.TeamsMeetingV2,
  ].includes(authenticator.type);
